import { render, staticRenderFns } from "./DuaMessageContainer.vue?vue&type=template&id=d28a9f96"
import script from "./DuaMessageContainer.vue?vue&type=script&lang=js"
export * from "./DuaMessageContainer.vue?vue&type=script&lang=js"
import style0 from "./DuaMessageContainer.vue?vue&type=style&index=0&id=d28a9f96&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports